import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { EnumPrefixConfig, prefixEnumsForAGraph } from '../../utils/ApiUtils';
import { ExposureTemplate } from '../AWExposureSearchServer';
import { isAGraphEnabled } from './AGraphUtils';
import { userPreferenceApi } from './Base';

const AGRAPH_REQUEST_ENUM_PREFIXES: EnumPrefixConfig[] = [
  { fieldNames: ['operator'], prefix: 'FILTER_OPERATOR_', recursiveFieldPatterns: ['selectedFilters'] },
  { fieldNames: ['valueType'], prefix: 'FILTER_VALUE_TYPE_', recursiveFieldPatterns: ['selectedFilters'] },
];

export async function getExposureTemplates(pkg: string) {
  const path = '/v1/exposures';
  const response = await userPreferenceApi.get<AGraphWrappedType<ExposureTemplate[], 'exposures'>>(path, {
    params: { pkg },
  });
  return unwrapAGraphResponse(response, 'exposures');
}

export async function saveExposureTemplate(template: Omit<ExposureTemplate, 'userPreferenceMetadata'>, pkg: string) {
  const path = '/v1/exposures';
  const payload = isAGraphEnabled() ? prefixEnumsForAGraph(template, AGRAPH_REQUEST_ENUM_PREFIXES) : template;
  const response = await userPreferenceApi.post<AGraphWrappedType<string, 'id'>>(path, payload, { params: { pkg } });
  return unwrapAGraphResponse(response, 'id');
}

export function deleteExposureTemplate(templateId: string, pkg: string) {
  const path = `/v1/exposures/${templateId}`;
  return userPreferenceApi.delete(path, { params: { pkg } });
}
